"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RightHandDrawer = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var Text_1 = require("../../atoms/Text");
var styles_1 = __importDefault(require("./styles"));
exports.RightHandDrawer = react_1.default.memo(function (_a) {
    var _b = _a.open, open = _b === void 0 ? false : _b, _c = _a.anchor, anchor = _c === void 0 ? 'right' : _c, _d = _a.onClose, onClose = _d === void 0 ? function () { } : _d, children = _a.children, _e = _a.width, width = _e === void 0 ? '250px' : _e, title = _a.title, controls = _a.controls, rest = __rest(_a, ["open", "anchor", "onClose", "children", "width", "title", "controls"]);
    var classes = (0, styles_1.default)();
    return ((0, jsx_runtime_1.jsxs)(core_1.Drawer, __assign({ className: classes.drawer, anchor: anchor, open: open, onClose: onClose }, rest, { children: [(0, jsx_runtime_1.jsx)("aside", { children: (0, jsx_runtime_1.jsxs)(core_1.Box, __assign({ width: width, minWidth: width, maxWidth: width, pt: "12px", px: "12px", pb: "20px" }, { children: [title && ((0, jsx_runtime_1.jsx)("header", { children: (0, jsx_runtime_1.jsx)(Text_1.Text, __assign({ className: classes.title, weight: "extra-bold" }, { children: title })) })), children] })) }), controls && ((0, jsx_runtime_1.jsx)(core_1.Box, __assign({ pt: "12px", px: "12px", pb: "20px", className: classes.controls }, { children: controls })))] })));
});
